module.exports = __webpack_public_path__ + "img/tiempo_de_lectura.a09b97ee.svg";